import createStyleSheet from 'onyx-common/createStyleSheet'

const createAndAttachStyleSheet = (styles, opts) => {
  const sheet = createStyleSheet(styles, opts)
  sheet.attach()
  return sheet
}

export default createAndAttachStyleSheet
